import router from './router';
import store from './store';
import { ElMessage as Message } from 'element-plus';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from './utils/get-page-title';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ['/login']; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);

  // Public routes are used by the third-party charging flow and must stay accessible without login.
  if (to.meta && to.meta.publicRoute) {
    next();
    return;
  }

  // determine whether the user has logged in
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' });
      NProgress.done();
    } else {
      if (!store.getters.addRouters.length) {
        try {
          const res = await store.dispatch('user/getUserMenu');
          await store.dispatch('GenerateRoutes', { res });
          // Vue Router 4: 动态添加路由
          const addRouters = store.getters.addRouters;
          addRouters.forEach((route) => {
            router.addRoute(route);
          });
          // 等待路由更新完成后再导航
          next({ ...to, replace: true });
        } catch (err) {
          console.log(err);
          next('/login');
        }
      } else {
        if (to.path === '/statisticsList'){
          let userInfo = store.getters.userInfo || {};
          let roleCodes = userInfo.roleCodes || [];
          if(roleCodes.indexOf(47)===-1 && roleCodes.indexOf(48)=== -1) {
            next();
          } else {
            next({ path: '/orderListAll', replace: true });
          }
        } else {
          next();
        }
      }
    }
  } else {
    /* has no token*/
    const res = [];
    store.dispatch('ResetRoutes', { res });
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
